module.exports = __webpack_public_path__ + "static/media/Plat.567916d4.png";